<template>
	<section class="view-feature-announcements">
		<ChalkyUiCoachMarkSequencer
			class="newfeature-coach-marks"
			v-bind:id="announcement.id"
			v-bind:key="announcement.id"
			v-bind:steps="announcement.steps"
			v-for="announcement in relevantAnnouncements"
		/>
	</section>
</template>

<script lang="ts">
	import * as Service from '@/App/Service';
	import ViewBase from '@/Core/View.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * Displays version-based feature announcements as coach marks.
	 * Integrates with VersionHistory to show relevant announcements
	 * based on which app versions the user has previously seen.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewFeatureAnnouncements extends ViewBase {
		/**
		 * Get announcements relevant to this user based on their version history.
		 *
		 * @return IVersionAnnouncement[]
		 */
		protected get relevantAnnouncements(): IVersionAnnouncement[] {
			return Service.FeatureAnnouncements.getAnnouncementsForUser();
		}
	}
</script>

<style lang="scss">
	.view-feature-announcements {
		// Container for feature announcement coach marks
	}
</style>
